import ContentOverlay from "../components/content_overlay";
import {Link} from "react-router-dom";


function ReportPage(){
    return (
        <ContentOverlay
        heading={ <h3 style={{textAlign:"center"}}>Reports</h3> }
        text_content={<div><p lang="en-US">&nbsp;</p>
            <ol>
            <li>
            
            <p><u><a href="data/reports/1_Assessing%20the%20accuracy%20of%20multi-model%20approaches%20for%20downscaling%20land%20surface%20temperature%20across%20diverse%20agroclimatic%20zones.pdf">Assessing the accuracy of multi-model approaches for downscaling land surface temperature across diverse agroclimatic zones.pdf</a></u></p></li></ol>
           
            <ol start="2">
            <li>
                        
            <p><u><a href="data/reports/2_Adapting%20%20cropping%20%20systems%20%20to%20%20future%20%20climate%20%20change%20%20scenario%20%20in%20%20three%20%20agro-climaticzones%20%20of%20%20Punjab,%20%20India.pdf">Adapting cropping systems to future climate change scenario in three agro-climaticzones of Punjab, India.pdf</a></u></p></li></ol>
           
            <ol start="3">
            <li>
                        
            <p><u><a href="data/reports/3_Assessing%20land%20surface%20temperature%20and%20land%20use%20change%20through%20spatio-temporal%20analysis%20a%20case%20study%20of%20select%20major%20cities%20of%20India.pdf">Assessing land surface temperature and land use change through spatio-temporal analysis a case study of select major cities of India.pdf</a></u></p></li></ol>
           
            <ol start="4">
            <li>
                        
            <p><u><a href="data/reports/4_Assessing%20the%20Impacts%20of%20Climate%20Change%20on%20Crop%20Yields%20in%20Different%20agro-climatic%20zones%20of%20india.pdf">Assessing the Impacts of Climate Change on Crop Yields in Different agro-climatic zones of india.pdf</a></u></p></li></ol>
           
            <ol start="5">
            <li>
                        
            <p><u><a href="data/reports/5_Climate%20change%20impacts%20on%20rainfall%20and%20temperature%20in%20sugarcane%20growing%20Upper%20Gangetic%20Plains%20of%20India.pdf">Climate change impacts on rainfall and temperature in sugarcane growing Upper Gangetic Plains of India.pdf</a></u></p></li></ol>
           
            <ol start="6">
            <li>
                        
            <p><u><a href="data/reports/6_Downscaling%20Land%20Surface%20Temperature%20at%20farm-scale%20using%20Multi-Model%20Approches%20over%20Diverse%20Agro%20Climatic%20Zones.pdf">Downscaling Land Surface Temperature at farm-scale using Multi-Model Approches over Diverse Agro Climatic Zones.pdf</a></u></p></li></ol>
           
            <ol start="7">
            <li>
                        
            <p><u><a href="data/reports/7_Downscaling%20Land%20Surface%20Temperature.pdf">Downscaling Land Surface Temperature.pdf</a></u></p></li></ol>
           
            <ol start="8">
            <li>
                        
            <p><u><a href="data/reports/8_Evaluating%20Daytime%20and%20Nighttime%20Land%20Surface%20Temperature%20Pattern%20and%20Trends%20in%20India%20A%20Comparative%20Analysis%20of%20Satellite%20and%20Reanalysis%20Data.pdf">Evaluating Daytime and Nighttime Land Surface Temperature Pattern and Trends in India A Comparative Analysis of Satellite and Reanalysis Data.pdf</a></u></p></li></ol>
           
            <ol start="9">
            <li>
                        
            <p><u><a href="data/reports/9_Evidence%20of%20asymmetric%20change%20in%20diurnal%20temperature%20range%20in%20recent%20decades%20over%20different%20agro-climatic%20zones%20of%20india.pdf">Evidence of asymmetric change in diurnal temperature range in recent decades over different agro-climatic zones of india.pdf</a></u></p></li></ol>
           
            <ol start="10">
            <li>
                        
            <p><u><a href="data/reports/10_Impact%20of%20climate%20change%20on%20Helicoverpa%20armigera%20voltinism%20in%20different%20Agro-Climatic%20Zones%20of%20India.pdf">Impact of climate change on Helicoverpa armigera voltinism in different Agro-Climatic Zones of India.pdf</a></u></p></li></ol>
           
            <ol start="11">
            <li>
                        
            <p><u><a href="data/reports/11_Impact%20of%20observed%20climate%20change%20on%20the%20classification%20of%20agroclimatic%20zones%20in%20India.pdf">Impact of observed climate change on the classification of agroclimatic zones in India.pdf</a></u></p></li></ol>
           
            <ol start="12">
            <li>
                        
            <p><u><a href="data/reports/12_Implications%20of%20climate%20change%20on%20surface%20temperature%20in%20North%20Indian%20states%20evidence%20from%20CMIP6%20model%20ensembles.pdf">Implications of climate change on surface temperature in North Indian states evidence from CMIP6 model ensembles.pdf</a></u></p></li></ol>
           
            <ol start="13">
            <li>
                        
            <p><u><a href="data/reports/13_Improvement%20in%20air%20quality%20and%20its%20impact%20on%20land%20surface%20temperature%20in%20major%20urban%20areas%20across%20India%20during%20the%20first%20lockdown%20of%20the%20pandemic.pdf">Improvement in air quality and its impact on land surface temperature in major urban areas across India during the first lockdown of the pandemic.pdf</a></u></p></li></ol>
           
            <ol start="14">
            <li>
                        
            <p><u><a href="data/reports/14_Innovative%20and%20polygonal%20trend%20analysis%20of%20temperature%20in%20agro-climatic%20zones%20of%20India.pdf">Innovative and polygonal trend analysis of temperature in agro-climatic zones of India.pdf</a></u></p></li></ol>
           
            <ol start="15">
            <li>
                        
            <p><u><a href="data/reports/15_Integrated%20Farming%20Systems%20as%20an%20Adaptation%20Strategy%20to%20Climate%20Change%20Case%20Studies%20from%20Diverse%20Agro-Climatic%20Zones%20of%20India.pdf">Integrated Farming Systems as an Adaptation Strategy to Climate Change Case Studies from Diverse Agro-Climatic Zones of India.pdf</a></u></p></li></ol>
           
            <ol start="16">
            <li>
                        
            <p><u><a href="data/reports/16_LAND%20SURFACE%20TEMPERATURE%20RESPONSES%20TO%20THE%20LAND.pdf">LAND SURFACE TEMPERATURE RESPONSES TO THE LAND.pdf</a></u></p></li></ol>
           
            <ol start="17">
            <li>
                        
            <p><u><a href="data/reports/17_Land%20surface%20temperature%20variability%20across%20India%20a%20remote%20sensing%20satellite%20perspective.pdf">Land surface temperature variability across India a remote sensing satellite perspective.pdf</a></u></p></li></ol>
           
            <ol start="18">
            <li>
                        
            <p><u><a href="data/reports/18_Land%20use%20and%20land%20cover%20change%20and%20their%20impact%20on%20temperature%20over%20central%20India.pdf">Land use and land cover change and their impact on temperature over central India.pdf</a></u></p></li></ol>
           
            <ol start="19">
            <li>
            
            <p><u><a href="data/reports/19_Projected%20climate%20extremes%20over%20agro-climatic%20zones%20of%20Ganga%20River%20Basin%20under%201.5,%202,%20and%203%C2%B0%20global%20warming%20levels.pdf">Projected climate extremes over agro-climatic zones of Ganga River Basin under 1.5, 2, and 3&deg; global warming levels.pdf</a></u></p></li></ol>
            <ol start="20">
            <li>
                        
            <p><u><a href="data/reports/20_Regional%20climate%20model%20performance%20and%20application%20of%20bias%20corrections%20in%20simulating%20summer%20monsoon%20maximum%20temperature%20for%20agro-climatic%20zones%20in%20India.pdf">Regional climate model performance and application of bias corrections in simulating summer monsoon maximum temperature for agro-climatic zones in India.pdf</a></u></p></li></ol>
           
            <ol start="21">
            <li>
                        
            <p><u><a href="data/reports/21_Seasonal%20and%20inter-annual%20variation%20in%20surface%20energy%20fluxes%20and%20forcing%20parameters%20in%20agro-climatic%20regions%20of%20India.pdf">Seasonal and inter-annual variation in surface energy fluxes and forcing parameters in agro-climatic regions of India.pdf</a></u></p></li></ol>
           
            <ol start="22">
            <li>
                        
            <p><u><a href="data/reports/22_Simulating%20the%20Impacts%20of%20Climate%20Change%20on%20Sugarcane%20in%20Diverse%20Agro-climatic%20Zones%20of%20Northern%20India%20Using%20CANEGRO-Sugarcane%20Model.pdf">Simulating the Impacts of Climate Change on Sugarcane in Diverse Agro-climatic Zones of Northern India Using CANEGRO-Sugarcane Model.pdf</a></u></p></li></ol>
           
            <ol start="23">
            <li>
                        
            <p><u><a href="data/reports/23_Spatial%20and%20temporal%20land%20surface%20temperature%20analysis%20of%20Kashmir%20valley%20(India).pdf">Spatial and temporal land surface temperature analysis of Kashmir valley (India).pdf</a></u></p></li></ol>
           
            <ol start="24">
            <li>
            
            <p><u><a href="data/reports/24_Spatio-temporal%20analysis%20of%20land%20surface%20temperature%20for%20identification%20of%20heat%20wave%20risk%20and%20vulnerability%20hotspots%20in%20Indo-Gangetic%20Plains%20of%20India.pdf">Spatio-temporal analysis of land surface temperature for identification of heat wave risk and vulnerability hotspots in Indo-Gangetic Plains of India.pdf</a></u></p></li></ol>
           
            <ol start="25">
            <li>
            
            <p><u><a href="data/reports/25_Temperature%20trend%20in%20different%20agro-climatic%20zones%20in%20India.pdf">Temperature trend in different agro-climatic zones in India.pdf</a></u></p></li></ol>
                        <ol start="26">
            <li>
                        
            <p><u><a href="data/reports/26_Climate%20Change%20Projections%20for%20India%20(2021%20-2040).pdf">Climate Change Projections for India (2021 -2040).pdf</a></u></p></li></ol>
                        <ol start="27">
            <li>
                        
            <p><u><a href="data/reports/27_Climate%20Atlas%20of%20India.pdf">Climate Atlas of India.pdf</a></u></p></li></ol>
           
            <ol start="28">
            <li>
                        
            <p><u><a href="data/reports/28_India%20Impact%20of%20Climate%20Change%20to%202030.pdf">India Impact of Climate Change to 2030.pdf</a></u></p></li></ol>
           
            <ol start="29">
            <li>
                        
            <p><u><a href="data/reports/29_Evaluation%20of%20temperature%20trends%20over%20India.pdf">Evaluation of temperature trends over India.pdf</a></u></p></li></ol>
           
            <ol start="30">
            <li>
                        
            <p><u><a href="data/reports/30_India%20Climate%20Change%20Impacts.pdf">India Climate Change Impacts.pdf</a></u></p></li></ol>
           
            <ol start="31">
            <li>
                        
            <p><u><a href="data/reports/31_New%20evidence%20highlights%20heat%20stress%20in%20rural%20India.pdf">New evidence highlights heat stress in rural India.pdf</a></u></p></li></ol>
           
            <ol start="32">
            <li>
                        
            <p><u><a href="data/reports/32_The%20costs%20of%20climate%20change%20in%20India.pdf">The costs of climate change in India.pdf</a></u></p></li></ol>
            <ol start="33">
            <li>
            
            <p><u><a href="data/reports/33_The%20Heat%20is%20on.pdf">The Heat is on.pdf</a></u></p></li></ol>
           
            <ol start="34">
            <li>
                        
            <p><u><a href="data/reports/34_United%20Nations%20Secretary-General%E2%80%99s%20Call%20to%20Action%20on%20Extreme%20Heat.pdf">United Nations Secretary-General&rsquo;s Call to Action on Extreme Heat.pdf</a></u></p></li></ol>
           
            <ol start="35">
            <li>
                        
            <p><u><a href="data/reports/35_Unusual%20rise%20in%20temperature%20due%20to%20climate%20change.pdf">Unusual rise in temperature due to climate change.pdf</a></u></p></li></ol>
           
            <ol start="36">
            <li>
                        
            <p><u><a href="data/reports/36_Climate%20Risk%20Country%20Profile.pdf">Climate Risk Country Profile.pdf</a></u></p></li></ol>
           
            <ol start="37">
            <li>
                        
            <p><u><a href="data/reports/37_Climate%20change%20by%20WHO.pdf">Climate change by WHO.pdf</a></u></p></li></ol>
           
            <ol start="38">
            <li>
            
            <p><u><a href="data/reports/38_How%20climate%20change%20affects%20extreme%20weather%20around%20the%20world.pdf">How climate change affects extreme weather around the world.pdf</a></u></p></li></ol>
           
            <ol start="39">
            <li>
                        
            <p><u><a href="data/reports/39_10%20Big%20Findings%20from%20the%202023%20IPCC%20Report%20on%20Climate%20Change.pdf">10 Big Findings from the 2023 IPCC Report on Climate Change.pdf</a></u></p></li></ol>
           
            <ol start="40">
            <li>
                        
            <p><u><a href="data/reports/40_State%20Level%20Climate%20Change%20Trends%20in%20India%202013.pdf">State Level Climate Change Trends in India 2013.pdf</a></u></p></li></ol>
           
            <ol start="41">
            <li>
                        
            <p><u><a href="data/reports/41_Climate%20Change%20and%20Heat-Induced%20Mortality%20in%20India.pdf">Climate Change and Heat-Induced Mortality in India.pdf</a></u></p></li></ol>
           
            <ol start="42">
            <li>
                        
            <p><u><a href="data/reports/42_Climate%20Change%20and%20India.pdf">Climate Change and India.pdf</a></u></p></li></ol>
           
            <ol start="43">
            <li>
                        
            <p><u><a href="data/reports/43_A%20Review%20of%20Heat%20and%20Health%20Research%20in%20India.pdf">A Review of Heat and Health Research in India.pdf</a></u></p></li></ol></div>}
        />

    )
}
export default ReportPage;